import { TStoryContentElementTypeOEmbedResponse } from "@dl/declarations";
import { useCallback } from "react";
import { InstagramEmbed, TikTokEmbed, XEmbed, YouTubeEmbed } from "react-social-media-embed";
import { HTMLEmbed } from "./HTMLEmbed";

interface OEmbedProps {
    config: Pick<TStoryContentElementTypeOEmbedResponse, "subtype" | "raw_oembed">
}

export const OEmbed: React.FC<OEmbedProps> = (props) => {
    const { config } = props;

    const renderEmbed = useCallback((subtype: string, html: string, url: string) => {
        if (url) {
            switch (subtype) {
                case "twitter":
                    return (
                        <XEmbed url={url} />
                    )

                    // return (
                    //     <HTMLEmbed config={{ content: html }} />
                    // )

                case "youtube":
                    return (
                        <YouTubeEmbed url={url} />
                    )

                case "instagram":
                    return (
                        <InstagramEmbed url={url} />
                    )

                case "tiktok":
                    return (
                        <TikTokEmbed url={url} />
                    )

                default:
                    return (
                        <HTMLEmbed config={{ content: html }} />
                    )
            }
        }

        return (
            <HTMLEmbed config={{ content: html }} />
        )
    }, []);

    return (
        renderEmbed(config.subtype, config.raw_oembed.html, config.raw_oembed.url)
    )
}
